import { SVGProps, memo } from 'react';
const Email = (props: SVGProps<SVGSVGElement>) => (

<svg width="202" height="109" viewBox="0 0 202 109" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4.04649" y="1.18907" width="158.992" height="106.622" rx="14.6567" fill="black" fill-opacity="0.04"/>
<rect x="4.04649" y="1.18907" width="158.992" height="106.622" rx="14.6567" stroke="#424242" stroke-width="0.612519"/>
<g clip-path="url(#clip0_1892_46080)">
<rect x="13.7148" y="11.1855" width="25.7258" height="25.7258" rx="11.0253" fill="white"/>
<circle cx="26.5771" cy="20.3735" r="5.51267" fill="#424242"/>
<circle cx="26.5799" cy="35.0736" r="7.96275" fill="#424242"/>
</g>
<rect x="48.627" y="18.3394" width="64.8395" height="11.2222" rx="2.45008" fill="#424242"/>
<rect x="13.7148" y="47.0186" width="110.975" height="9.97531" rx="2.45008" fill="#424242"/>
<rect x="125.938" y="47.0186" width="27.4321" height="9.97531" rx="2.45008" fill="#BDBDBD"/>
<rect x="13.7148" y="64.4756" width="120.951" height="9.97531" rx="2.45008" fill="#424242"/>
<rect x="134.666" y="64.4756" width="18.7037" height="9.97531" rx="2.45008" fill="#BDBDBD"/>
<rect x="13.7148" y="82.5" width="139.654" height="10.4128" rx="2.45008" fill="#424242"/>
<circle cx="154.617" cy="45.7716" r="29.9259" stroke="white" stroke-width="8.7284"/>
<path d="M173.318 70.7104L197.01 94.4018" stroke="white" stroke-width="4.98765" stroke-linecap="round"/>
<circle cx="154.614" cy="45.7715" r="29.9259" stroke="#424242" stroke-width="2.49383"/>
<path d="M173.318 70.7095L197.01 94.4008" stroke="#424242" stroke-width="2.5" stroke-linecap="round"/>
<defs>
<clipPath id="clip0_1892_46080">
<rect x="13.7148" y="11.1855" width="25.7258" height="25.7258" rx="11.0253" fill="white"/>
</clipPath>
</defs>
</svg>
);

export default memo(Email)